// extracted by mini-css-extract-plugin
export default {"versionInfo":"VersionInfo_versionInfo__U09ay"};